var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 14.8 17 1.8c-.3-.3-.7-.5-1.2-.5s-.9.2-1.2.5l-12.5 13c-.7.7-.6 1.7 0 2.4.3.3.8.5 1.2.5s.9-.2 1.2-.5l.6-.9V29c0 .9.8 1.7 1.7 1.7H13c.9 0 1.7-.8 1.7-1.7v-6.7h2.6V29c0 .9.8 1.7 1.7 1.7h6.2c.9 0 1.7-.8 1.7-1.7V16.1l.7 1c.7.7 1.7.6 2.4 0 .5-.6.5-1.7-.2-2.3m-6.4 12.5h-2.8v-6.7c0-.9-.8-1.7-1.7-1.7H13c-.9 0-1.7.8-1.7 1.7v6.7H8.5V12.8l7.4-7.5 7.5 7.4z"
  })));
};
export default SvgHouse;